<template>
    <section class="section-about">
        <div class="about">

            <div class="row myview">
                <h1 class="heading-secondary about__header ">About This Site</h1>
                <p class="about__paragraph">
                    This site includes a hand-picked collection of articles in programming and data science and
                    leverages Machine Learning for its key features. Currently the site includes two main views, the
                    home and the summarize pages, and a centralized navigation/menu process.
                </p>
                
                <p class="about__paragraph">
                    The home page includes a card-based layout of collected articles with infinite scrolling and
                    enhanced search capabilities. Each article is linked to its original site and displays an image, a
                    title, and the date it was collected; also, it includes a summary (SUM) and a recommendation (REC)
                    links. When hovering over the card, the SUM and REC links will pulsate to get the visitor’s
                    attention. When clicked, the SUM link will display a summary (highlights) for the article and the
                    REC link will display a list of recommended related articles. The site leverages Python based
                    Natural Language Processing libraries to build the recommendation system (content-based) and to
                    generate the highlights (extractive text summarization).
                </p>
                <p class="about__paragraph">
                    The summarize page enables the visitor to generate highlights to any website. The process includes
                    copying everything from the target web page and then pasting in the available input text area.
                    Approximately 30 sec after clicking the “GET HIGHLIGHTS” button, the highlights will be displayed
                    bellow the text input area.
                </p>
                <p class="about__paragraph">
                    To navigate, click on the hamburger button (top right) and then select the view from the top menu
                    items (home, summarize, and about). If the current view is the home page, clicking the hamburger
                    button will also display a list of years, which can be used to filter and display the data collected
                    for that year. The selected year and its corresponding number of articles are displayed under the
                    search input area on the landing/home page.
                </p>
                <p class="about__paragraph">
                    Be sure to read the instructions on searching and resetting the filtered data as indicated in the
                    search input placeholder.
                </p>
                <p class="about__paragraph">
                    The back-end leverages FLASK web service (Python based), which is responsible for hosting and
                    serving the generated machine learning models and site data. The front-end is based on VUE.JS
                    framework and uses VUEX for its state management. Also, the site leverages advanced CSS and SCSS
                    implementations for it’s responsive design.
                </p>
                <!--                <h1 class="heading-secondary about__header ">Other Personal sites:</h1>-->
                <!--              <p>-->
                <!--                <h1 class="heading-tertiary about__header "> Arabidopsis Plant Lipids Metabolism data visualization:</h1>-->
                <!--                <ul>-->
                <!--                    <li><a href="http://dynviz.azurewebsites.net/forcedirected"></a></li>-->
                <!--                    <li><a href=" https://public.tableau.com/profile/basilshorrosh#!/vizhome/Arabidopsis/ArabidopsisAcyl-Lipids">-->
                <!--                        https://public.tableau.com/profile/basilshorrosh#!/vizhome/Arabidopsis/ArabidopsisAcyl-Lipids-->
                <!--                    </a></li>-->
                <!--                </ul>-->
                <!--                <h1 class="heading-tertiary about__header ">Bioinformatics</h1>-->
                <!--                <ul>-->
                <!--                    <li><a href="http://plasmidtrek.com"> Web based plasmid drawing and cloning program.-->
                <!--                    </a></li>-->
                <!--                    <li><a href=" http://aralip.plantbiology.msu.edu/">ARABIDOPSIS  ACYL-LIPID METABOLISM</a></li>-->
                <!--                    <li><a href="https://plantfadb.org/"> Exploring Phylogenetic Relationships between Hundreds of Plant Fatty Acids Synthesized by Thousands of Plants.-->
                <!--                    </a></li>-->
                <!--                </ul>-->
                <!--                </p>-->

                <p class="about__paragraph">
                    I hope you find the site useful.
                    <!--                    Please send me an <a href="mailto:plasmidtrek@gmail.com" style="font-style: italic;">email</a> if-->
                    <!--                    you have any questions or suggestions. -THANKS.-->
                </p>

                <p style="font-style: italic">© Copyright 2019 Basil Shorrosh </p>

            </div>
        </div>
    </section>
</template>
<script>
    // @ is an alias to /src
    export default {
        name: 'about__paragraph',
        components: {},
        mounted() {
            // setTimeout(()=> {
            this.$eventHub.$emit('filter-data-visible', false)
            // },200)
        }
    }
</script>
<style lang="scss">

</style>
